import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, Mail, MapPin, Clock } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_8e64f860-a2c3-4880-99a2-0e37e54f65c6/artifacts/lq6grz4s_CB3D4111-0127-441A-AEB4-FB146D6CBB1E.png";

export default function Footer() {
  return (
    <footer className="bg-[#003366] text-white">
      {/* Main footer */}
      <div className="max-w-[1440px] mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company info */}
          <div>
            <img src={LOGO_URL} alt="IPVALUE Managements" className="h-12 mb-4" />
            <p className="text-slate-300 text-sm mb-4">
              Your trusted destination for quality products at unbeatable prices. Shop with confidence.
            </p>
            <div className="flex gap-3">
              <a href="#" className="text-slate-300 hover:text-[#FFD700] transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-slate-300 hover:text-[#FFD700] transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-slate-300 hover:text-[#FFD700] transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-slate-300 hover:text-[#FFD700] transition-colors">
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h3 className="font-semibold text-[#FFD700] mb-4">Shop</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/products" className="text-slate-300 hover:text-white transition-colors">All Products</Link></li>
              <li><Link to="/products?deal=true" className="text-slate-300 hover:text-white transition-colors">Today's Deals</Link></li>
              <li><Link to="/products?category=cat-electronics" className="text-slate-300 hover:text-white transition-colors">Electronics</Link></li>
              <li><Link to="/products?category=cat-home" className="text-slate-300 hover:text-white transition-colors">Home & Garden</Link></li>
              <li><Link to="/products?category=cat-fashion" className="text-slate-300 hover:text-white transition-colors">Fashion</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="font-semibold text-[#FFD700] mb-4">Customer Service</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/account" className="text-slate-300 hover:text-white transition-colors">My Account</Link></li>
              <li><Link to="/track-order" className="text-slate-300 hover:text-white transition-colors">Order Tracking</Link></li>
              <li><Link to="/faq" className="text-slate-300 hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="text-slate-300 hover:text-white transition-colors">Contact Us</Link></li>
              <li><Link to="/about" className="text-slate-300 hover:text-white transition-colors">About Us</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-[#FFD700] mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2 text-slate-300">
                <MapPin size={16} />
                <span>950 28th St SE, 49508 MI</span>
              </li>
              <li className="flex items-center gap-2 text-slate-300">
                <Mail size={16} />
                <span>support@ipvaluemanagements.com</span>
              </li>
              <li className="flex items-start gap-2 text-slate-300">
                <Clock size={16} className="mt-0.5" />
                <span>Open 7 days/week<br />9am - 9pm Eastern</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#002244]">
        <div className="max-w-[1440px] mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-400">
            <p>© 2025 IPVALUE Managements. All rights reserved.</p>
            <div className="flex gap-4">
              <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
              <Link to="/faq" className="hover:text-white transition-colors">Shipping Info</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
